<template>
  <div v-if="showModel"
       @click="close($event)"
       class="login_box">
    <div id="login_container" >
      <div class="login_text">请登录</div>
      <div>
        <div><input id="phonenum" class="phonenum_input" type="text" placeholder="请输入手机号"
                    v-model="phone"
                    value=""/></div>
        <div class="authcode_div">
          <input id="code"
                 v-model="code"
                 class="authcode_input"
                 type="text" placeholder="请输入验证码"/>
          <input id="second"
                 type="button"
                 @click="sendCode"
                 v-model="sendHtml"
                 value="获取验证码"/>
        </div>
      </div>
      <div>
        <button class="login_button" @click="codelogin">登录</button>
      </div>
      <div class="third_login_text">推荐使用第三方登录</div>
      <div class="third_party">
        <img id="wechat"
             @click="loginWechat"
             src="http://www.caiyunapp.com//user/login/imgs/wechat.png">
        <img id="qq"
             @click="loginQq"
             src="http://www.caiyunapp.com//user/login/imgs/qq.png">
        <img id="weibo"
             @click="loginWeibo"
             src="http://www.caiyunapp.com//user/login/imgs/weibo.png">
      </div>
    </div>
  </div>

</template>
<style scoped>
  .login_box{
    position: fixed;
    left:0;
    right:0;
    bottom:0;
    top:0;
    background: rgba(100,100,100,.35);
  }
  h1 {
    font-size: 30px;
    font-weight: 200;
    margin-bottom: 30px;
  }

  .authcode_div {
    display: block;
    position: relative;
    margin: auto;
    border-bottom: 1px solid #D8D8D8;
    width: 340px;
    height: 60px;
  }

  .phonenum_input {
    width: 320px;
    border-width: 0px;
    border-bottom: 1px solid #D8D8D8;
    padding: 12px 10px;
    margin-top: 36px;
    color: #333;
  }

  .authcode_input {
    width: 200px;
    height: 44px;
    position: absolute;
    left: 0;
    bottom: 2px;
    padding-left: 10px;
    border-width: 0px;
    text-align: left;
    color: #333;
    /*padding: 12px 0px;*/
    /*border-bottom-width: 1px;*/
  }

  #second {
    /*border-bottom: 1px solid #D8D8D8;*/
    /*float: right;*/
    position: absolute;
    right: 0;
    bottom: 12px;
    font-size: 14px;
    color: #00B977;
    overflow: hidden;
    text-align: right;
    align-content: flex-end;
    border-width: 0px;
    background: white;
    cursor: pointer;
    border-left: 1px solid #F0F0F0;;
  }

  .login_text {
    font-size: 20px;
    color: #333333;
    text-align: center;
    margin-top: 30px;
  }

  .third_login_text {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 19px;
  }

  .login_button {
    background: #00B977;
    border-radius: 5px;
    width: 340px;
    height: 50px;
    margin-top: 30px;
    text-align: center;
    cursor: pointer;
    color: white;
    padding: 0px;
    border-width: 0px;
  }
  #login_container {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 12px;
    bottom: 0;
    z-index: 9999;
    background-color: #ffffff;
    text-align: center;
    opacity: 0.96;
    width: 420px;
    height: 440px;
  }

  #wechat {
    height: 48px;
    cursor: pointer;
  }

  #qq {
    height: 48px;
    margin-left: 60px;
    margin-right: 60px;
    cursor: pointer;
  }

  #weibo {
    height: 48px;
    cursor: pointer;
  }
  .nav>li>a.no-logged-in{
    display: none;
  }
  .nav>li>a.no-logged-out{
    display: none;
  }
</style>
<script>
  import { getUserData, logout } from '@/api/user'
  import { sendCode ,codeloginsend} from '@/api/login'
  let REDIRECT_URI = "http://staging.caiyunapp.com/web/login_redirect";
  export default {
    name: "LoginModel",
    data() {
      return {
        avatarUrl: "",
        activeIndex: "",
        phone:'',
        countdown:60,
        sendHtml:'获取验证码',
        codeId:'',
        sendDisabled:false,
        code:'',
        showModel:false
      };
    },
    mounted (){
//      this.initData();
    },
    methods: {
      loginWechat(){
        var re_uri = this.getReURI("wexin");
        var url = "https://open.weixin.qq.com/connect/qrconnect?appid=wx90147eeca723142b&redirect_uri=" + re_uri + "&response_type=code&scope=snsapi_login&state=LOGIN#wechat_redirect"
        location.href = url;
      },
      loginQq(){
        var re_uri = this.getReURI("qq");
        var url = "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101435941&scope=get_user_info&state=LOGIN&redirect_uri=" + re_uri;
        location.href = url;
      },
      loginWeibo(){
        var re_uri = encodeURIComponent(REDIRECT_URI + "?plf=weibo");
        var url = "https://api.weibo.com/oauth2/authorize?client_id=3979371825&response_type=code&redirect_uri=" + re_uri;
        location.href = url;
      },
      initData(){
        let user = getUserData();
        if (user && user.avatar) {
          this.avatarUrl = user.avatar
        } else {
          this.avatarUrl = "https://caiyunapp.com/imgs/webtrs/default.png"
        }
      },
      handleSelect(key, keyPath) {
        if (key === '/fanyi') {
//          window.location.href = '/fanyi'
        } else if (key === '/api') {
          window.location.href = "//wiki.swarma.net/index.php/%E5%BD%A9%E4%BA%91%E5%B0%8F%E8%AF%91API"
        }
      },
      handleCommand(command) {
        if (command === 'logout') {
          logout().then(responce => {
            window.location.href = '/'
          });
        }
      },
      toIndex() {
        if (window.location.href.indexOf("fanyi.caiyunapp.com") >= 0) {
          window.location.href = "//caiyunapp.com"
        } else {
          window.location.href = "/"
        }
      },
      getReURI(plf) {
    if (location.href.indexOf("/fanyi") >= 0 || location.href.indexOf("translate.") >= 0) {
      return encodeURIComponent(REDIRECT_URI + "?plf=" + plf + "&re_url=" + location.href);
    }
    return encodeURIComponent(REDIRECT_URI + "?plf=" + plf);
  },
      addCookie(name, value, expiresHours) {
    //判断是否设置过期时间,0代表关闭浏览器时失效
    if (expiresHours > 0) {
      var date = new Date();
      date.setTime(date.getTime() + expiresHours * 1000);
      $.cookie(name, escape(value), {expires: date});
    } else {
      $.cookie(name, escape(value));
    }
  },
      sendCode(obj) {
          var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
          if (!myreg.test(this.phone)) {
              alert('请输入有效的手机号码！');
              return false;
          }
          sendCode(this.phone).then(res=>{
              console.log(res);
            if (res.status == "ok") {
              this.codeId = res.codeId
              this.addCookie("secondsremained", 60, 61);//添加cookie记录,有效时间60s
              this.settime(obj);//开始倒计时
            } else {
              this.codeId = res.codeId;
              alert("验证码发送失败，请重试")
            }
          }).catch(err => {
              console.log(err);
            this.codeId = err.codeId;
            console.log("this.codeId:"+this.codeId);
            alert("验证码发送失败，请重试");
          })
      },
      getCookieValue(name) {
        return $.cookie(name);
      },
      editCookie(name, value, expiresHours) {
        if (expiresHours > 0) {
          var date = new Date();
          date.setTime(date.getTime() + expiresHours * 1000); //单位是毫秒
          $.cookie(name, escape(value), {expires: date});
        } else {
          $.cookie(name, escape(value));
        }
      },
      settime() {
          this.countdown = this.getCookieValue("secondsremained");
            if (!this.countdown || this.countdown <= 0) {
                this.sendHtml = '获取验证码';
                this.sendDisabled = false;
            return;
          } else {
              this.sendDisabled = true;
              this.sendHtml=`重新获取(" + ${this.countdown} + "s)`;
              this.countdown--;
              this.editCookie("secondsremained", this.countdown, this.countdown + 1)

          }
          setTimeout(function () {
             this.settime()
          }, 1000) //每1000毫秒执行一次
      },
      codelogin() {
        console.log("this.codeId:"+this.codeId);
          if (!this.code) {
              alert("请输入验证码");
            return false;
          }
          if (!this.phone) {
              alert("请输入手机号");
              return false;
          }
        codeloginsend(this.phone, this.codeId,this.code)
          .then(res=>{
            if (res.status == "ok") {
                if (location.href.indexOf("/fanyi") >= 0 || location.href.indexOf("translate.") >= 0) {
                  location.href = location.href;
                } else {
                location.href = "/"
              }
            } else {
                if (res.rc == -902) {
                    alert("验证码有误或已过期");
                } else {
                    alert("登录失败，请重试")
                }
            }
        }).catch(err=>{
          alert("抱歉，网络请求有误，请重试");
        })
      },
      show(){
          this.showModel = true;
      },
      hide(){
          this.showModel = false;
      },
      close(e){
          if(e.target.className ==='login_box'){
              this.hide();
          }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/LoginModel.vue